import type { KeyboardEvent } from 'react';
import TableEmptyRow from 'components/others/TableEmptyRow';
import type { ClientContactRow } from '../model/clientContactTypes';
import ClientContactsTableRow from './ClientContactsTableRow';

interface ClientContactsTableBodyProps {
    rows: ClientContactRow[];
    emptyText: string;
    disabled: boolean;
    canEdit: boolean;
    editingKey: string | null;
    editValue: string;
    onEditValueChange: (value: string) => void;
    onEditKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
    onStartEdit: (row: ClientContactRow) => void;
    onSaveEdit: () => void;
    onCancelEdit: () => void;
    onRemove: (row: ClientContactRow) => void;
}

const ClientContactsTableBody = ({
    rows,
    emptyText,
    disabled,
    canEdit,
    editingKey,
    editValue,
    onEditValueChange,
    onEditKeyDown,
    onStartEdit,
    onSaveEdit,
    onCancelEdit,
    onRemove,
}: ClientContactsTableBodyProps) => (
    <tbody>
        {!rows.length ? (
            <TableEmptyRow colSpan={3} className="text-muted text-center py-3">
                {emptyText}
            </TableEmptyRow>
        ) : (
            rows.map((row) => (
                <ClientContactsTableRow
                    key={row.localKey}
                    row={row}
                    disabled={disabled}
                    canEdit={canEdit}
                    editing={editingKey === row.localKey}
                    editValue={editValue}
                    onEditValueChange={onEditValueChange}
                    onEditKeyDown={onEditKeyDown}
                    onStartEdit={() => onStartEdit(row)}
                    onSaveEdit={onSaveEdit}
                    onCancelEdit={onCancelEdit}
                    onRemove={() => onRemove(row)}
                />
            ))
        )}
    </tbody>
);

export default ClientContactsTableBody;
